// Moment should always be imported from here. This will enforce that the timezone
// is always included. There were some problems when Origem Flow is installed as a
// dependency and then moment-timezone does not work. Still will resolve that issue.
import moment from 'moment-timezone'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/de'
import 'moment/dist/locale/es'
import 'moment/dist/locale/it'
import 'moment/dist/locale/pl'
import 'moment/dist/locale/ko'
import 'moment/dist/locale/uk'
import 'moment/dist/locale/pt'
import 'moment/dist/locale/pt-br'

// Origem Flow: todos os calendários (timeline, planner e qualquer
// startOf('week')) começam a semana no domingo, independente do locale.
const activeLocale = moment.locale()
moment.locales().forEach((locale) => {
  moment.updateLocale(locale, { week: { dow: 0 } })
})
moment.locale(activeLocale)

export default moment
